import styled from 'styled-components'
import { v1 as color, media } from 'sidecar-design-library'

import Icon from '../IconV1'

export const InputButtonGroup = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  border-radius: 0.3125rem;
  background: ${color.WHITE} // stack buttons vertically when on small screens
    ${p =>
      p.stack &&
      media.mobileAndBelow`
    flex-direction: column;
  `};
`

export const StyledIcon = styled(Icon)`
  font-size: 1.875rem;
`

export const StyledButton = styled.label`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  text-align: center;
  position: relative;
  border: solid 1px #aaa;
  cursor: pointer;
  overflow: hidden;
  padding: 0.875rem;
  color: #0e60c9;
  transition: all 0.2s;

  small {
    color: ${color.GREY};
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  // we're going to use a :before element
  // to pull off our fancy double border
  &:before {
    content: '';
    position: absolute;
    top: 0.125rem;
    left: 0.125rem;
    bottom: 0.125rem;
    right: 0.125rem;
    border: solid 1px transparent;
    transition-duration: all 0.2s;
  }

  &:first-child {
    border-radius: 0.3125rem 0 0 0.3125rem;

    &:before {
      border-radius: 0.3125rem 0 0 0.3125rem;
    }

    // round top corners for vertical stacks
    ${p =>
      p.stack &&
      media.mobileAndBelow`
      border-radius: 0.3125rem 0.3125rem 0 0;

      &:before {
        border-radius: 0.3125rem 0.3125rem 0 0;
      }
    `}
  }

  // neg margin allows this elements border
  // to show over its siblings border on hover
  &:not(:first-child):not(:last-child) {
    border-radius: 0;
    margin-left: -1px;
    border-left: none;

    &:before {
      border-radius: 0;
    }

    // disable the offset margin when vertically stacked
    ${p =>
      p.stack &&
      media.mobileAndBelow`
      margin-left: 0;
      margin-top: -1px;
    `}
  }

  &:last-child {
    border-radius: 0 0.3125rem 0.3125rem 0;
    margin-left: -1px;

    &:before {
      border-radius: 0 0.3125rem 0.3125rem 0;
    }

    // round bottom corners for vertical stacks
    ${p =>
      p.stack &&
      media.mobileAndBelow`
      border-radius: 0 0 0.3125rem 0.3125rem;
      margin-left: 0;
      margin-top: -1px;

      &:before {
        border-radius: 0 0 0.3125rem 0.3125rem;
      }
    `}
  }

  // increasing z-index on hover is what lets
  // the colored borders show correctly.
  ${p =>
    !p.disabled &&
    `
    &:hover {
      color: #0E60C9;
      border-color: #0E60C9;
      z-index: 10;
    }

    &:focus-within {
      &:before {
        border: solid 1px #0E60C9;
      }
    }
    
    &:active {
      border: 1px solid #0E60C9;
      color: #0E60C9;

      &:before {
        border-color: #0E60C9;
      }

      &:first-child:not(:last-child) {
        &:before {
          border-radius: 3px 0 0 3px;
        }
      }

      &:last-child:not(:first-child) {
        &:before {
          border-radius: 0 3px 3px 0;
        }
      }
    }
  `}

  ${p =>
    p.selected &&
    `
    background: #F1F5F9;
    border: solid 1px #0E60C9;
    color: #0E60C9;

    &:focus-within {
      background: #fff;

      &:before {
        background: #F1F5F9;
        border: solid 1px #0E60C9;
      }
    }
  `}

  ${p =>
    p.invalid &&
    `
    background: #fff;
    border: solid 1px ${color.WATERMELON};
    color: ${color.WATERMELON};
  `}

  ${p =>
    p.disabled &&
    `
    background: white;
    color: ${color.GREY};
    border-color: ${color.GREY};
    cursor: default;
    ${
      p.selected &&
      `
      background: ${color.SMOKE};
      border: solid 1px ${color.MORTAR};

      & span[class^='sidecon-'] {
        color: ${color.MORTAR};
      }
    `
    }
  `}
`

// we can't just display:none the radio because
// users won't be able to tab to these buttons.
// Also don't use top and left because it makes the
// page jump to the top when users click the buttons.
export const StyledRadio = styled.input`
  position: absolute;
  z-index: -999;
  visibility: hidden;
`
